import { createSelector } from '@ngrx/store';
import { AppState, IndicatorData } from '../app.state';

export const selectIndicatorMap = createSelector(
  (state: AppState) => state.indicator,
  (indicatorMap: Map<string, IndicatorData>) => indicatorMap
);
